import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import URL from 'modules/url'
import * as actions from 'actions'
import assets from 'modules/assets'
import Header from 'components/Utils/Header'
import Footer from 'components/Utils/Footer'
import AlertMini from 'components/Utils/AlertMini'
import RowThreeText from 'components/Utils/RowThreeText'
import * as digitalData from 'modules/digital'
import Spinner from 'components/Utils/Spinner'

class Digital extends Component {
  componentDidMount() {
    let { dispatch } = this.props
    let url = URL(this.props)
    dispatch(actions.token.fetchData(url))
    this.state = {
      data: this.props.data,
      location: this.props.location
    }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data,
      location: nextProps.location
    })
  }
  render() {
    let digital, jobs = false
    if (this.state && this.state.data) {
      digital = digitalData.digital(this.state.data)
      jobs = digitalData.jobs(this.state.data)
    }

    let url1 = assets('images/.png')
    let green = {
      backgroundImage: 'url(' + url1 + ')',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '0 0',
      backgroundSize: 'cover'
    }
    let url2 = assets('images/.png')
    let red = {
      backgroundImage: 'url(' + url2 + ')',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '30%',
      backgroundPosition: 'bottom right'
    }

    let scrollJobsIntoView = this.state && this.state.location && this.state.location.hash === '#apply'
    if (scrollJobsIntoView) {
      this.props.router.push(this.state.location.pathname)
    }

    let main
    if (!digital) {
      main = <div className="layer parallax__layer--base"><Spinner /></div>
    } else {
      main = (
        <div className="layer parallax__layer--base">
          <img src={assets('images/digital-green.png')} id="deep-1" style={{width: '100%', right: '0', position: 'absolute', height: 'auto', minHeight: '100vh'}} />
          <RowThreeText data={digital}/>
          <RowThreeText data={jobs} isScrollIntoView={scrollJobsIntoView}/>
          <img src={assets('images/blobs/02.png')} style={{width: '100%', height: 'auto', marginTop: '25vh', marginBottom: '-1px'}} />
          <Footer />
        </div>
      )
    }
    return (
      <main className="page fade-in">
        <AlertMini alertIsMinimized={true} />

        <div className="group0 parallax__group">
          {main}
        </div>
      </main>
    )
  }
}
Digital.contextTypes = {
}
Digital.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
    location: ownProps.location,
    data: state.token.data
  }
}

export default connect(mapStateToProps)(Digital)



// WEBPACK FOOTER //
// ./src/components/Digital.js